// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__17g7Q","col":"styles_col__2x__3"};